import React from "react";
import { array, bool, func } from "prop-types";
import { Link } from "@quintype/components";
import sortBy from "lodash/sortBy";

import "./custom-suggestion-list.m.css";

const CustomSuggestionList = ({ data, onClick }) => (
  <ul styleName="list-container">
    {data.length ? (
      sortBy(data, [obj => obj.name]).map((o, index) => {
        return (
          <li key={index} onClick={() => onClick(o)}>
            <Link styleName="list-item">{o.name}</Link>
          </li>
        );
      })
    ) : (
      <li styleName="list-item-empty">No results found...</li>
    )}
  </ul>
);

CustomSuggestionList.propTypes = {
  data: array,
  isSearching: bool,
  onClick: func
};

export default CustomSuggestionList;
